module.exports = __webpack_public_path__ + "static/media/GuessMyNumber.4f1d695a.jpg";